<template>
  <div class="one_box">
      <div class="one_main">
          <div class="two_form_box">
            <el-form label-position="top">
                <!-- 第一块 -->
                <div class="one_m_tit1">{{$t('main.text23')}}</div>
                <div class="one_m_tit2">{{$t('main.text82')}}</div>
                <template>
                    <div v-for="(item,index) in one_arr" :key="item.sjs">
                        <el-form-item :label="`${$t('main.text131')} ${index+1}`">
                            <div class="num_lift">
                                <el-input :disabled="input_dab" v-model="item.name"></el-input>
                                <span @click="item.is_show=!item.is_show">
                                    <i class="el-icon-arrow-up icon_up" v-if="item.is_show"></i>
                                    <i class="el-icon-arrow-down" v-else></i>
                                </span>
                            </div>
                        </el-form-item>

                        <template v-if="item.is_show">
                            <div>
                                <el-form-item :label="$t('main.text132')">
                                    <el-input :disabled="input_dab" v-model="item.ownership"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('main.text133')">
                                    <el-input :disabled="input_dab" v-model="item.passport_number"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('main.text134')">
                                    <el-select filterable :disabled="input_dab" v-model="item.issuer" :placeholder="$t('main.text135')">
                                        <el-option v-for="(item,index) in country" :key="index" :label="item.name" :value="item.name"></el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- 上传 -->
                                <!-- :show-file-list="show_child" -->
                                <!-- :file-list="set_item_url(item.url,index)" -->
                                <el-form-item>
                                    <div class="box_top_tit">{{$t('main.text87_y')}}</div>
                                    <el-upload
                                    :disabled="input_dab"
                                    class="upload-demo upload_box"
                                    drag
                                    :limit="10"
                                    action="#"
                                    ref="upload-file"
                                    :show-file-list="true"
                                    :file-list="set_item_url(item.url,index)"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                    :http-request="ossUpload_assistant"
                                    :before-remove="function(file,fileList){child_beforeRemove(file,fileList,index)}"
                                    :data="{data_index:index}"
                                    multiple>
                                        <img class="load_icon" src="../../../assets/img/user_upload_img.png" alt="">
                                        <div class="el-upload__text upload_text">
                                        <div>{{$t('main.text88')}}</div>
                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                        <div>{{$t('main.text90')}}</div>
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </div>
                        </template>
                    </div>
                </template>

                <el-form-item>
                    <div><el-button :disabled="input_dab" class="add_yellow_btn" @click="add_one_arr">{{$t('main.text136')}}</el-button></div>
                    <div class="add_btm_text">{{$t('main.text137')}}</div>
                </el-form-item>

                <!-- 第二块 -->
                <div class="one_m_tit1 two_top">{{$t('main.text138')}}</div>
                <template>
                    <div v-for="(item,index) in two_arr" :key="index">
                        <el-form-item :label="$t('main.text83')">
                            <div class="num_lift">
                                <el-input :disabled="input_dab" v-model="item.name"></el-input>
                                <span @click="item.is_show=!item.is_show">
                                    <i class="el-icon-arrow-up icon_up" v-if="item.is_show"></i>
                                    <i class="el-icon-arrow-down" v-else></i>
                                </span>
                            </div>
                        </el-form-item>

                        <template v-if="item.is_show">
                            <div>
                                <el-form-item :label="$t('main.text139')">
                                    <el-input :disabled="input_dab" v-model="item.position"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('main.text133')">
                                    <el-input :disabled="input_dab" v-model="item.years_of_service"></el-input>
                                </el-form-item>
                            </div>
                        </template>
                    </div>
                </template>

                <el-form-item>
                    <div><el-button :disabled="input_dab" class="add_yellow_btn" @click="add_two_arr">{{$t('main.text140')}}</el-button></div>
                    <div class="add_btm_text">{{$t('main.text137')}}</div>
                </el-form-item>
              
              <el-form-item>
                <el-button :disabled="input_dab" class="Submit_btn" @click="upload_all_data">{{$t('main.text104')}}</el-button>
              </el-form-item>
            </el-form>
          </div>
      </div>
  </div>
</template>

<script>
import {awsS3Auth,getKycInfo,kyc_shareholder} from '@/api/api';
import AWS from 'aws-sdk';

export default {
    data() {
        return {
            awsS3_data:'',
            show_child:true,
            one_arr:[
                {
                    sjs:this.createCode(),
                    is_show:true,
                    name:'',
                    ownership:'',
                    passport_number:'',
                    issuer:'',
                    url:[],
                    uid:[]
                },
            ],
            child_index_j:null,

            two_arr:[
                {
                    is_show:true,
                    name:'',
                    position:'',
                    years_of_service:'',
                },
            ],

            one_data_all:false,//是否全部填写数据
            two_data_all:false,//是否全部填写数据
            input_dab:false,
            country:'',

            api_old_data1:'',//老数据
            api_old_data2:'',//老数据


            
        }
    },
    created() {
      if(this.v_lan=='ch'){
        this.country=require("@/assets/country_en/country_ch.json");
      }else{
        this.country=require("@/assets/country_en/country.json");
      }
    },
    mounted() {
        this.S3Auth();
        this.get_kyc();
        this.bus.$on('router_4_child',(v)=>{
            if(v==3){
                // 重新触发 保存操作
                this.upload_all_data();
            }
        })
    },
    destroyed(){
        this.bus.$off('router_4_child')
    },
    watch:{
        one_arr:{ //监听的对象
            deep:true, //深度监听设置为 true
            handler:function(newV,oldV){
                newV;oldV;
                this.old_data_new_data();
            }
        },
        two_arr:{ //监听的对象
            deep:true, //深度监听设置为 true
            handler:function(newV,oldV){
                newV;oldV;
                this.old_data_new_data();
            }
        }
        
    },
    methods: {
        // 随机数
        createCode() {
            var code = "";
            var codeLength = 10;
            var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
            for (var i = 0; i < codeLength; i++) {
                var index = Math.floor(Math.random() * 9);
                code += random[index];
            }
            return code;
        },
        set_item_url(item_url,index){
            
            let url=[];
            index;
            

            for (let i = 0; i < item_url.length; i++) {
                let text1=item_url[i];
                let text2=[];
                text2=text1.split("/");
                url.push({name:text2[5],url:text1})
            }
            return url;
        },

        add_one_arr(){
            if(this.one_arr.length<5){
                this.one_arr.push({
                    sjs:this.createCode(),
                    is_show:true,
                    name:'',
                    ownership:'',
                    passport_number:'',
                    issuer:'',
                    url:[],
                    uid:[]
                    })
            }else{
                
                this.message.ismessage('error',this.$t('main.text141'));
            }
        },
        add_two_arr(){
            if(this.two_arr.length<5){
                this.two_arr.push({
                    is_show:true,
                    name:'',
                    position:'',
                    years_of_service:'',
                    })
            }else{
                
                this.message.ismessage('error',this.$t('main.text141'));
            }
        },
        async S3Auth() {
            const res = await awsS3Auth();
            if (res.data.code == 200) {
                this.awsS3_data = res.data.data;
                
                //参数
                AWS.config.update({
                region: "ap-southeast-1",
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: this.awsS3_data.IdentityPoolId,
                    IdentityId: this.awsS3_data.IdentityId,
                    Logins: {
                    "cognito-identity.amazonaws.com": this.awsS3_data.Token,
                    },
                }),
                });
            }else{
                
                this.message.ismessage('error',res.data.msg);
            }
        },
        ossUpload_assistant(data){
            data;
            this.$store.state.aws_loading = true;
            this.show_child=false;
            let file_type = data.file.type.split("/")[1];
            const uploadPath =  'autonym/'+this.createCode()+'/'+this.random_16+'.'+file_type;
            let s3 = new AWS.S3();
            let params = {
                Body: data.file,
                Bucket: "data-storage-d3",
                Key: uploadPath,
                ACL: "public-read",
            };
            s3.putObject(params,(err)=>{
                if(err){
                    console.error('error');
                    console.log(err);
                    console.log(err, err.stack);
                    alert(err, err.stack);
                    this.$store.state.aws_loading=false;
                }else{
                    const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
                    this.one_arr[data.data.data_index].url.push(url);
                    this.one_arr[data.data.data_index].uid.push(data.file.uid);
                    this.$store.state.aws_loading=false;
                    this.show_child=true;
                }
            })
        },
        child_beforeRemove(file,fileList,index){
            file;fileList;index;
            for (let j = 0; j < this.one_arr[index].url.length; j++) {
                if(this.one_arr[index].url[j].indexOf(file.url)!=-1){
                    this.child_index_j=j;
                    break;
                }
            }
            this.one_arr[index].url.splice(this.child_index_j,1);
            this.one_arr[index].uid.splice(this.child_index_j,1);
        },
        upload_all_data(){

            //此方法内的this指向
            var that = this;
            
            let flag = that.one_arr.every(item =>{
                return item.name==''&&item.ownership==''&&item.passport_number==''&&item.issuer==''&&item.url.length<=0&&item.uid.length<=0
            })
            let flag2 = that.two_arr.every(item =>{
                return item.name==''&&item.position==''&&item.years_of_service==''
            })
            if (flag&&flag2) {
                
                this.message.ismessage('error',this.$t('main.text107'));
                this.$store.state.login.data_no_router=false;
                return false;
            }

            for (let i = 0; i < this.one_arr.length; i++) {
                if(
                    this.one_arr[i].name&&
                    this.one_arr[i].ownership&&
                    this.one_arr[i].passport_number&&
                    this.one_arr[i].issuer&&
                    this.one_arr[i].url.length>0&&
                    this.one_arr[i].uid.length>0
                ){
                    this.one_data_all=true;
                    break;
                }
            }
            
            
            for (let i = 0; i < this.two_arr.length; i++) {
                if (this.two_arr[i].name&&this.two_arr[i].position&&this.two_arr[i].years_of_service) {
                    this.two_data_all=true;
                    break;
                }
            }
            
            

            kyc_shareholder({
                shareholder_status:(this.one_data_all&&this.two_data_all)?1:0,
                shareholder_ownership:this.one_arr,
                shareholder_main_offices:this.two_arr
            }).then(res=>{
                if(res.data.code==200){
                    
                    this.message.ismessage('success',this.$t('main.text108'));
                    this.get_kyc();
                    
                    setTimeout(() => {
                        this.bus.$emit('info_4_all');
                    }, 100);
                }else{
                    
                    this.message.ismessage('error',res.data.msg);
                    this.$store.state.login.data_no_router=false;
                }
            })



        },
        get_kyc(){
            getKycInfo().then(res=>{
                if(res.data.code==200){
                    

                    let old_data;
                    if(res.data.data.shareholder_ownership&&res.data.data.shareholder_ownership!=''){
                        old_data=JSON.parse(res.data.data.shareholder_ownership);
                    }
                    let old_data_set=[];
                    if(old_data){
                        for (let i = 0; i < old_data.length; i++) {
                            for (const key in old_data[i]) {
                                
                                if ("is_show" in old_data[i]) {
                                    
                                    old_data_set=old_data;
                                    break;
                                }else{
                                    
                                    old_data[i][key]={
                                            ...old_data[i],
                                            sjs:this.createCode(),
                                            is_show:true,
                                            ownership:'',
                                            passport_number:'',
                                            issuer:''
                                        }
                                        old_data_set.push(old_data[i][key]);
                                        break;
                                }
                            }
                        }
                        this.one_arr=old_data_set;
                        this.api_old_data1=JSON.parse(JSON.stringify(old_data_set));//老数据

                    }

                    

                    if(res.data.data.shareholder_main_offices&&res.data.data.shareholder_main_offices!=''){
                        let data2 = JSON.parse(res.data.data.shareholder_main_offices);
                        this.two_arr=data2;
                        this.api_old_data2=JSON.parse(JSON.stringify(data2));//老数据
                        
                    }else{
                        
                        this.api_old_data2=JSON.parse(JSON.stringify(this.two_arr));//老数据
                    }
                    

                    // status 2 待审核   3审核中  4审核通过  5审核失败
                    if(
                        res.data.data.status==2||
                        res.data.data.status==3||
                        res.data.data.status==4||
                        res.data.data.status==5
                        ){
                            this.input_dab=true;
                    }else{
                        this.input_dab=false;
                    }

                    

                }else{
                    
                    this.message.ismessage('error',res.data.msg);
                }
            })
        },
        old_data_new_data(){
            if(this.api_old_data1&&this.one_arr&&this.api_old_data2&&this.two_arr){
                let data_true=((JSON.stringify(this.api_old_data1) == JSON.stringify(this.one_arr)&&(JSON.stringify(this.api_old_data2) == JSON.stringify(this.two_arr))));
                
                this.$store.state.login.router_true=data_true;
            }else if((this.api_old_data1==''&&this.one_arr)||(this.api_old_data2==''&&this.two_arr)){
                // console.log(this.api_old_data1);
            }

        },

    },
}
</script>

<style scoped>
.one_box{
    flex: 1;
    background: #04182A;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 60px 0;
}
.one_main{
    width: 420px;
    margin: auto;
}
.one_m_tit1{
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 8px;
}
.one_m_tit2{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 40px;
}
.one_m_tit3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 8px;
}
.one_m_tit4 .el-radio__label{
    font-size: 15px;
}
.one_m_tit4 >>> .el-radio{
    color: #fff;
}
.one_m_tit4 >>> .el-radio__inner {
    border: 1px solid #fff;
    background-color: transparent;
}
.one_m_tit4 >>> .el-radio__input.is-checked .el-radio__inner {
    border-color: #fff;
    background: transparent;
}
.one_m_tit4 >>> .el-radio__inner::after {
    width: 7px;
    height: 7px;
    background-color: #fff;
}
.one_m_tit4 >>> .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
}
.one_m_tit4 >>> .el-radio__inner:hover {
    border-color: #fff;
}
.add_yellow_btn,
.add_yellow_btn:hover{
    width: 214px;
    height: 46px;
    background: #04182A;
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    margin: auto;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    color: #DEB981;
    border-color: #DEB981;
    display: block;
    margin-top: 20px;
    margin-bottom: 12px;
}
.add_btm_text{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
}
.two_top{
    margin-top: 20px;
}



/* --上传-- */
.upload_header{
    height: 104px;
    background: #041728;
    display: flex;
    position: relative;
}
.upload_t_logo{
    width: 230px;
    margin: auto;
}
.upload_t_btn{
  border: 1.5px solid #F1C787;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
  color: #F1C787;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translate(0,-50%);
}
.form_box{
    max-width: 420px;
    margin: auto;
    margin-top: 40px;
}
.form_tit{
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    color: #314869;
    margin-top: 60px;
}
.upload_box >>> .el-upload{
    width: 100%;
}
.upload_box >>> .el-upload-dragger{
    background: rgba(222, 185, 129, 0.04);
    border: 1.5px dashed #DEB981;
    border-radius: 4px;
    width: 100%;
    height: 190px;
}
.icon_upload{
    margin: 10px auto 0;
    font-size: 50px;
}
.upload_text div{
    line-height: initial;
    color: rgba(255, 255, 255, 0.6);
}
.upload_btn{
    border-color: #F1C788;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-weight: bold;
    font-size: 15px;
    /* line-height: 18px; */
    color: #04182A;
    margin: 12px auto;
    height: 38px;
}
.box_top_tit{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    opacity: 0.6;
    margin-bottom: 12px;
}
.el-form-item {
    margin-bottom: 15px;
}
.add_btn{
    width: 214px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #191E29;
    border: 1px solid #00C18E;
    cursor: pointer;
    margin: 30px auto;
    /* box-shadow: 0px 2px 4px rgb(222 185 129 / 20%); */
}
.Submit_btn,
.Submit_btn:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    border-color: #F1C788;
    width: 100%;
    color: #04182A;
    margin-bottom: 30px;
    margin-top: 20px;
}
.load_icon{
    width: 30px;
    vertical-align: middle;
    margin-top: 25px;
    margin-bottom: 10px;
}
.upload_body >>> .el-upload-list__item .el-icon-close-tip{
    display: none !important;
    color: transparent;
}
/* --over-- */

/* --form-- */
.two_form_box >>> .el-form--label-top .el-form-item__label{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.two_form_box >>> .el-input__inner{
  background: #223C58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  color: #fff;
}
.two_form_box .el-select {
  width: 100%;
}
.num_lift{
  position: relative;
  margin-bottom: 8px;
}
/* .el-form-item .num_lift:last-child{
  margin-bottom: 0;
} */
.num_lift span{
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
}
/* .num_lift >>> .el-input__inner{
  text-indent: 1em;
} */
/* --over-- */
/* 滚动条 */
.one_box {
  overflow: auto;
  height: calc(100vh - 120px);
}
.one_box::-webkit-scrollbar {
  width: 5px;
}
.one_box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #F1C788;
}
/* --over-- */

.one_box >>> .el-upload-list{
  height: 100px;
  /* background: pink; */
  overflow: auto;
}
/* 滚动条 */
.one_box >>> .el-upload-list {
  overflow: auto;
}
.one_box >>> .el-upload-list::-webkit-scrollbar {
  width: 5px;
}
.one_box >>> .el-upload-list::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background: #687eec;
}
/* --over-- */

</style>
<style>
.el-upload-list__item {
    transition: none !important;
}
.el-upload-list__item
.el-upload-list__item-name{
    transition: none !important;
}
.icon_up:before {
    content: "\e6e1" !important;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
    .one_main {
        margin: inherit;
        width: 90%;
    }


}
</style>